export default {
    methods: {
        downloadCsv (data, fileName) {
            const blob = new Blob([data], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)
            // Creating an anchor(a) tag of HTML
            const a = document.createElement('a')

            // Passing the blob downloading url
            a.setAttribute('href', url)

            // Setting the anchor tag attribute for downloading
            // and passing the download file name
            a.setAttribute('download', fileName)

            // Performing a download with click
            a.click()
        },

        jsonToCsv (data, header) {
            const replacer = (key, value) => (value || value === 0 || value === false) ? value : ''
            const csv = [
                header.join(','), // header row first
                ...data.map((row) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
            ].join('\r\n')
            return csv
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/jsonToCsv.js